module.exports = __webpack_public_path__ + "img/profitability7.771b9884.png";